import Innholdsfortegnelse from "./Innholdsfortegnelse";

export default Innholdsfortegnelse;
